export default "__VITE_ASSET__DZ4MhLE___"